import { useState, useEffect } from 'react';
import { useGetPlanInfo } from '../services/planService';

// Custom hook to handle country selection logic
export const useCountrySelection = () => {
  const [showCountryModal, setShowCountryModal] = useState(false);
  const [hasCheckedCountry, setHasCheckedCountry] = useState(false);
  
  const { planInfo, planInfoIsLoading } = useGetPlanInfo();

  // Check if country selection is needed
  useEffect(() => {
    if (planInfo && !planInfoIsLoading && !hasCheckedCountry) {
      setHasCheckedCountry(true);
      
      // Show modal if country is missing
      if (!planInfo.country) {
        setShowCountryModal(true);
      }
    }
  }, [planInfo, planInfoIsLoading, hasCheckedCountry]);

  // Handle successful country selection
  const handleCountrySelectionSuccess = (updatedPlanInfo) => {
    setShowCountryModal(false);
    // Optionally refresh plan info or update local state
  };

  // Manually trigger country selection (for testing or manual triggers)
  const triggerCountrySelection = () => {
    setShowCountryModal(true);
  };

  // Close modal without selection
  const closeCountryModal = () => {
    setShowCountryModal(false);
  };

  return {
    showCountryModal,
    triggerCountrySelection,
    closeCountryModal,
    handleCountrySelectionSuccess,
    planInfo,
    planInfoIsLoading,
    needsCountrySelection: !planInfo?.country && !planInfoIsLoading
  };
};